import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";

import { fetchPreventiveFilters } from "../slices/getPreventiveFilters";

export const useGetPreventiveFilters = () => {
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth.token);
    const filtersRaw = useSelector((state) => state.preventiveFilters.filterList);
    const loaded = useSelector((state) => state.preventiveFilters.loaded);

    useEffect(() => {
        if (!token || loaded) {
            return;
        }
        dispatch(fetchPreventiveFilters({ token }));
    }, [dispatch, token, loaded]);

    return { filters: filtersRaw?.data || {} };
};